$(document).ready(function() {
    // Show popup when the link is clicked
    $('#search-dsk').click(function() {
    $('#box-dsk').show(); // Use fadeIn for smooth visibility
    });

    // Hide popup when the close button is clicked
    $('.closePopup').click(function() {
    $('#box-dsk').hide(); // Use fadeOut for smooth disappearance
    });
});

$(document).ready(function() {
    // Show popup when the link is clicked
    $('#search-mob').click(function() {
        $('#box-mob').show(); // Use fadeIn for smooth visibility
    });
    
    // Hide popup when the close button is clicked
    $('.closePopup').click(function() {
        $('#box-mob').hide(); // Use fadeOut for smooth disappearance
    });
});
$('#testimonial-three-col').owlCarousel({
    loop:false,
    margin:0,
    nav:false,
	dots:false,
	autoHeight:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
})